// import logo from './logo.svg';
import './App.css';
import React from 'react';
import { Amplify } from 'aws-amplify'
import { API } from '@aws-amplify/api'
import config from './aws-exports'
import { listAllCustomers } from './graphql/queries'
import * as mutations from './graphql/mutations';
import QRCode from "react-qr-code";
import { withAuthenticator, Button } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';

API.configure(config)

Amplify.configure({
  Auth: {
    region: 'Us-West-2',
    userPoolId: 'us-west-2_v4dQtljqM',
    userPoolWebClientId: '6mgce9nvqqcev8frnfhpe7m2jg',
    mandatorySignIn: false,
    oauth: {
      domain: 'https://waitlist-chriswon.auth.us-west-2.amazoncognito.com',
      scope: ['email', 'openid'],
      redirectSignIn: 'https://waitlist.chriswon.ca/index.html',
      responseType: 'code'
    }
  }
})

/**
 * Main component, displays the waitlist table
 */
class DisplayTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = { showQRCode: false, QRCode: "", inEditMode: { on: false, rowKey: null }, currentStatus: "", tableData: [], table: "", showInput: false };
  }

  componentDidMount() {
    this.loadAllCustomers();
  }

  /**
     *
     * @param id - The id of the customer
     * @param currentStatus - The current status of the customer
     */
  onEdit = ({ id, status }) => {
    this.setState({
      inEditMode: {
        status: true,
        rowKey: id
      }
    })
    this.setState({ currentStatus: status });
  }

  /**
       *
       * @param id -The id of the customer
       * @param newStatus - The new status of the customer
       */
  onSave = async ({ item, newStatus }) => {
    try {
      await API.graphql({
        query: mutations.updateCustomer,
        variables: {
          customer: {
            id: item.id,
            name: item.name,
            status: newStatus,
            comments: item.comments,
            createdAt: item.createdAt
          },
        }
      })
    } catch (e) { console.error(e) }

    //update the data array with the new status
    const newTableData = this.state.tableData.map((row) => {
      if (item.id === row.id) {
        return { ...item, status: newStatus };
      } else {
        return row;
      }
    })
    this.setState({ tableData: newTableData })
    this.onCancel();
  }

  // hide the extra buttons revealed by clicking on Edit by resetting the inEditMode state value
  onCancel = () => {
    this.setState({
      inEditMode: {
        status: false,
        rowKey: null
      }
    })
    this.setState({ currentStatus: "" });
  }

  /**
   * Load all existing customers from the Appsync endpoint; used periodically to update status and
   * to reload in the case of errors/crashes. Used instead of subscribes based on the premise that 
   * instant updates aren't needed and sufficient activity will occur to call this regularly.
   */
  loadAllCustomers = async () => {
    try {
      const response = await API.graphql({
        query: listAllCustomers
      })
      let sortedData = response.data.listAllCustomers;
      sortedData.sort((a, b) => a.createdAt.localeCompare(b.createdAt))
      this.setState({ tableData: sortedData })
    } catch (e) { console.error(e) }
  }

  /**
   * Create a new customer entry and create a QR Code for the customer to load the client app.
   * @param e Contains the form data for the new customer
   */
  create = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const name = String(formData.get('customer'));
    const status = String(formData.get('status'));
    const comments = String(formData.get('comments'));

    const response = await API.graphql({
      query: mutations.newCustomer,
      variables: {
        customer: {
          name: name,
          status: status,
          comments: comments
        },
      }
    })
    this.setState({ showInput: false })
    this.loadAllCustomers();

    // const qrCode = <div style={{ height: "auto", margin: "0 auto", maxWidth: "10%", width: "100%", padding: "20px" }}>

    const url = "https://waitlist.chriswon.ca/client/index.html?id=" + response.data.newCustomer.id;
    const qrCode = <div class="qr">
      <QRCode
        size={256}
        value={url}
        viewBox={`0 0 256 256`}
      />
    </div>
    this.setState({ QRCode: qrCode })
    this.setState({ showQRCode: true })
  }

  /**
   * Delete a specific customer.
   * @param {string} id ID of the customer to delete
   */
  onDelete = async (id) => {
    await API.graphql({
      query: mutations.deleteCustomer,
      variables: {
        id: id
      }
    })
    this.loadAllCustomers()
  }

  /**
   * Toggles the rendering of certain page elements
   * @param e 
   */
  reveal = (e) => {
    e.preventDefault();
    this.setState({ showInput: !this.state.showInput })
  }

  inputForm = (
    <form onSubmit={this.create}>
      <label>
        Customer Name:
        <input name="customer" />
      </label>

      <label>
        Status:
        <select name="status">
          <option value="WAITING">WAITING</option>
          <option value="ENROUTE">ENROUTE</option>
          <option value="NOTIFIED">NOTIFIED</option>
          <option value="REJECTED">REJECTED</option>
          <option value="SEATED">SEATED</option>
        </select>
      </label>

      <label>
        Comments:
        <input name="comments" />
      </label>
      <Button class="NewCustomer" type="submit">Submit</Button>
      <Button class="NewCustomer" onClick={this.reveal}>Cancel</Button>
    </form>
  );

  render() {
    return (
      <div className="container">
        <table>
          <thead>
            <tr>
              <th>#</th>
              <th>Customer Name</th>
              <th>Comments</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {
              this.state.tableData.map((item, index) => (
                <tr key={item.id}>
                  <td>{index + 1}</td>
                  <td>{item.name}</td>
                  <td>{item.comments}</td>
                  <td>
                    {
                      this.state.inEditMode.status && this.state.inEditMode.rowKey === item.id ? (
                        <select value={this.state.currentStatus} onChange={(e) => this.setState({ currentStatus: e.target.value })}>
                          <option value="WAITING">WAITING</option>
                          <option value="NOTIFIED">NOTIFIED</option>
                          <option value="SEATED">SEATED</option>
                        </select>
                      ) : (
                        item.status
                      )
                    }
                  </td>
                  <td>
                    {
                      this.state.inEditMode.status && this.state.inEditMode.rowKey === item.id ? (
                        <React.Fragment>
                          <Button
                            className={"btn-success"}
                            onClick={() => this.onSave({ item: item, newStatus: this.state.currentStatus })}
                          >
                            Save
                          </Button>
                          <Button
                            className={"btn-secondary"}
                            style={{ marginLeft: 8 }}
                            onClick={() => this.onCancel()}
                          >
                            Cancel
                          </Button>
                          <Button
                            className={"btn-secondary"}
                            style={{ marginTop: 4 }}
                            onClick={() => this.onDelete(item.id)}
                          >
                            Delete
                          </Button>
                        </React.Fragment>
                      ) : (
                        <Button
                          className={"btn-primary"}
                          onClick={() => this.onEdit({ id: item.id, status: item.status })}
                        >
                          Edit
                        </Button>
                      )
                    }
                  </td>
                </tr>
              ))
            }
          </tbody>
        </table>
        {this.state.showInput ? null : <Button onClick={this.reveal}>Add New Customer</Button>}
        {this.state.showInput ? this.inputForm : null}
        {this.state.showQRCode ? this.state.QRCode : null}
        {this.state.showQRCode ? <div class="qr"><Button onClick={() => this.setState({ showQRCode: false })}>Hide QR Code </Button></div> : null}
      </div>
    );
  }
}

//user object contains both ID and Access Tokens; both can be used to access appsync
function App({ signOut, user }) {
  return (
    <div className="container">
      <div className="signout">
        <Button style={{ width: '20vw', maxWidth: '250px' }} onClick={signOut}>Sign out</Button>
      </div>
      <header className="App-header">
        <h1>Waiting List</h1>
      </header>
      <DisplayTable />
    </div>
  );
}

export default withAuthenticator(App, { hideSignUp: true });